import React from "react";
import { Box } from "@mui/material";
import { CustomPdfModal } from "@ippon/shared-components";

interface Props {
  signedUrl: string;
  fileName: string;
  fileType: string;
}

const isPdfDocument = (fileType: string, fileName: string): boolean => {
  if (fileType === "application/pdf") return true;
  return fileName.toLowerCase().endsWith(".pdf");
};

/**
 * 支出 OCR モーダルの form step で左ペインに表示する、取り込み元ファイルのプレビュー。
 * PDF はブラウザ標準 PDF プラグインだと width:100% を無視して溢れることがあるため、
 * pdfjs-dist で親要素幅に合わせて canvas 描画する CustomPdfModal を使う。
 * 画像は <img> を contain 表示。
 */
const ExpenseOcrPdfPanel: React.FC<Props> = ({
  signedUrl,
  fileName,
  fileType,
}) => {
  const isPdf = isPdfDocument(fileType, fileName);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 0,
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        border: "1px solid #e9e9e9",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#525252",
      }}
    >
      {isPdf ? (
        <CustomPdfModal pdfUrl={signedUrl} fillHeight />
      ) : (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          }}
        >
          <Box
            component="img"
            src={signedUrl}
            alt={fileName}
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ExpenseOcrPdfPanel;
